import { useQuery } from '@tanstack/react-query';

import { DepartmentResource } from '@/types/resources';
import { api } from '@/utils/api';

const useDepartmentsOptions = () => {
  return useQuery(
    ['departments_and_units'],
    () => api.get<never, DepartmentResource[]>('/v1/departments'),
    {
      select: (data) =>
        data.map((item) => ({
          value: item.id,
          label: item.name,
          hide_from_dropdowns: item.hide_from_dropdowns,
          companyNames: item.companies.map((c) => c.name).join(', '),
        })),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
    },
  );
};

export default useDepartmentsOptions;
